import { IUnitPaymentMethodsRepository } from 'modules/customer/domain/repositories';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import {
  PAYMENT_METHOD_TO_DOMAIN,
  TVectisPaymentMethodType,
} from 'shared/infra/adapters';

export default class VectisUnitPaymentMethodsRepository
  implements IUnitPaymentMethodsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findAll: IUnitPaymentMethodsRepository['findAll'] = async ({
    unitId,
  }) => {
    const methods = await this.httpProvider.get<TVectisPaymentMethodType[]>(
      `unidades/formasPagamentoParcela/${unitId}`,
    );

    return methods
      .map(method => PAYMENT_METHOD_TO_DOMAIN[method])
      .filter(method => !!method);
  };
}
